import { render, staticRenderFns } from "./SuccessfullModal.vue?vue&type=template&id=0b9f4a05&"
import script from "./SuccessfullModal.vue?vue&type=script&lang=js&"
export * from "./SuccessfullModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports